import React from 'react'
import IconBase from '../IconBase'

const svgContent = <svg width="1em" height="1em" viewBox="0 0 16 16" focusable="false" fill="currentColor" aria-hidden="true"><g fill="none" fillRule="evenodd"><circle fill="#23CFE6" cx={5} cy={8} r={5} /><circle fill="#3491FA" opacity={0.8} cx={11} cy={8} r={5} /></g></svg>

const WallPaperTitle = React.forwardRef((props, ref) => {
  return (
    <IconBase name="wall-paper-title" {...props} ref={ref}>
      {svgContent}
    </IconBase>
  )
})

WallPaperTitle.displayName = 'IconWallPaperTitle'

export default WallPaperTitle
